import { RefreshCw } from "lucide-react";
import { useLocale } from "../../../context/LanguageContext";

interface StopRecurrenceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  entityType: "challenge" | "event";
  entityName: string;
}

export function StopRecurrenceDialog({
  isOpen,
  onClose,
  onConfirm,
  loading,
  entityType,
  entityName,
}: StopRecurrenceDialogProps) {
  if (!isOpen) return null;

  const { t } = useLocale();

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-50 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-lg border border-border bg-card p-6 shadow-xl">
          <div className="mb-4 flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-warning/10 text-warning">
              <RefreshCw className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                {t("shared.stopRecurrence.title")}
              </h3>
              <p className="mt-1 text-sm text-muted-foreground">
                {entityType === "challenge"
                  ? t("shared.stopRecurrence.messageChallenge", { name: entityName })
                  : t("shared.stopRecurrence.messageEvent", { name: entityName })}
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="inline-flex h-9 items-center rounded-md border border-border px-4 text-sm font-medium text-foreground hover:bg-muted disabled:opacity-50"
            >
              {t("shared.stopRecurrence.keepRecurring")}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className="inline-flex h-9 items-center rounded-md bg-warning px-4 text-sm font-medium text-warning-foreground hover:bg-warning/90 disabled:opacity-50"
            >
              {loading ? t("shared.stopRecurrence.stopping") : t("shared.stopRecurrence.yesStop")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
